export default "__VITE_ASSET__d0472813__"